
import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';



import Home from "./components/pages/Home";
import Footer from "./components/inc/Footer";
import Contactus from './components/pages/Contactus';
import Aboutus from './components/pages/Aboutus';
import Productpage from './components/pages/Productpage';

function App() {
  return (
   <Router>

      <div>



        <Routes>


          <Route axact path="/" element={<Home />} />
             <Route axact path="/contact-us" element={<Contactus/>} />
               <Route axact path="/aboutus" element={<Aboutus/>} />
                <Route axact path="/products" element={<Productpage/>} />
       
      

     </Routes>
      <Footer/>

      </div>

    </Router>
  );
}

export default App;
